module.exports = "<mat-toolbar>\n    <span class=\"summary-bar-element\">Total: {{ total | currency }}</span>\n    <span class=\"summary-bar-element\">Equities: {{ equities | currency }}</span>\n    <span class=\"summary-bar-element\">Cash: {{ cash | currency }}</span>\n    <!-- <span class=\"market-opening\">Markets opening in 9 hours</span> -->\n</mat-toolbar>\n"


//////////////////
// WEBPACK FOOTER
// /Users/thibautjacob/Documents/Projects/Portfolio/src/app/components/summary-bar/summary-bar.component.html
// module id = ../../../../../src/app/components/summary-bar/summary-bar.component.html
// module chunks = main